
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/privacy/2024-08-12",
      function () {
        return require("private-next-pages/[locale]/legal/privacy/2024-08-12.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/privacy/2024-08-12"])
      });
    }
  